const fieldTypes = {
  master: true,
  intAsString: true,
  epoch: true,
  string: true,
  enum: true,
  boolean: true
}

export const entryTypeFields = {
  entryType: {
    label: 'ENTRY TYPE',
    apiKey: 'entryType',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== 'NONE' || ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  liveEntryIndicator: {
    label: 'LIVE ENTRY INDICATOR',
    apiKey: 'liveEntryIndicator',
    type: fieldTypes,
    rules: [],
    errors: [],
    valid: true
  },
  summaryDate: {
    label: 'SUMMARY DATE',
    apiKey: 'summaryDate',
    type: fieldTypes.date,
    rules: [
      {
        test: value => {
          return value !== null && value !== ''
        },
        message: 'Field required'
      },
      {
        test: value => {
          let primaryStatementPrintDate = document.getElementById('primaryStatementPrintDate' + window.shipmentId).value
          if(!value)return true;//ignore this rule if we don't have one of the dates
          if(!primaryStatementPrintDate) return true;//ignore this rule if we don't have one of the dates
          let psprintdate = new Date(primaryStatementPrintDate)
          let entrydate = new Date(value)
          return psprintdate.getTime() > entrydate.getTime()
        },
        message: 'Entry Date cannot be greater than preliminary statement print date!!'
      }
    ],
    errors: [],
    valid: true,
    getHSAPIValue: (summaryDate) => {
      if (summaryDate && summaryDate !== -999) {
        return summaryDate.toString()
      } else {
        return Date.now().toString()
      }
    }
  },
  filerCode: {
    label: 'FILER CODE',
    apiKey: 'filerCode',
    type: fieldTypes,
    rules: [],
    errors: [],
    valid: true
  },
  entryNumber: {
    label: 'ENTRY NUMBER',
    apiKey: 'entryNumber',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== ''
        },
        message: 'Field required'
      },
      {
        test: value => {
          return value.length === 7
        },
        message: 'Entry Number should be of length 7'
      }
    ],
    errors: [],
    valid: true
  },
  statementPaymentType: {
    label: 'Statement Payment Type',
    apiKey: 'statementPaymentType',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== 'NONE' || ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  periodicStatementMonths: {
    label: 'PERIODIC STATEMENT MONTH',
    apiKey: 'periodicStatementMonths',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== 'NONE' || ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  primaryStatementPrintDate: {
    label: 'Preliminary Statement Print Date',
    apiKey: 'primaryStatementPrintDate',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== -999
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  portCode: {
    label: 'Port of Entry Code',
    apiKey: 'portCode',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== '_BLANK_' && value !== '' && value !== undefined
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  countryOfExport: {
    label: 'COUNTRY OF EXPORT',
    apiKey: 'countryOfExport',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== 'NONE' || ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  itNumber: {
    id: 'itNumber',
    label: "I.T. Number",
    apiKey: 'itNumber',
    type: fieldTypes,
    rules: [],
    errors: [],
    valid: true
  },
  itDate: {
    id: 'itDate',
    label: "I.T. Date",
    apiKey: 'itDate',
    type: fieldTypes,
    rules: [],
    errors: [],
    valid: true
  },
  locationOfGoods: {
    id: 'locationOfGoods',
    label: 'Location Of Goods (FIRMS)',
    info:"Report the FIRMS Code of the customs bonded warehouse where the goods are to be delivered.",
    apiKey: 'locationOfGoods',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  currentLocationOfGood: {
    id: 'currentLocationOfGood',
    label: 'FIRMS (CURRENT LOCATION)',
    info:"Report pier or site where the merchandise is currently available for examination.",
    apiKey: 'currentLocationOfGood',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
}
